module.exports = __webpack_public_path__ + "d31b85f175eab931a89234817fbe96b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user_small.svg
// module id = 351
// module chunks = 0